import {
  POST_ADD_MODULE,
  POST_ADD_MODULE_ERROR,
  POST_ADD_MODULE_LOADING,
  GET_TUTORIAL_DETAILS,
  POST_EDIT_MODULE,  // Action type for editing module
  POST_EDIT_MODULE_ERROR, // Error action type for edit
  POST_EDIT_MODULE_LOADING, // Loading action type for edit
} from '../actions/types';


const initialState = {
  loading: false,
  userList: [],  // This is your list of modules
  error: null,
  isAddingModule: false, // For managing the loading state of adding module
  isEditingModule: false, // For managing the loading state of editing module
  tutorailDetails : {}
};

const moduleReducer = (state = initialState, action) => {
  switch (action.type) {
    // Add Module Actions
    case POST_ADD_MODULE_LOADING:
      return {
        ...state,
        isAddingModule: true,
      };

    case POST_ADD_MODULE:
      return {
        ...state,
        isAddingModule: false,
        userList: [...state.userList, action.payload.module], // Assuming the response has 'module'
      };

    case POST_ADD_MODULE_ERROR:
      return {
        ...state,
        isAddingModule: false,
        error: action.payload,
      };

    // Edit Module Actions
    case POST_EDIT_MODULE_LOADING:
      return {
        ...state,
        isEditingModule: true,
      };

    case POST_EDIT_MODULE:
      return {
        ...state,
        isEditingModule: false,
        userList: state.userList.map(module =>
          module.id === action.payload?.data?.id ? action.payload?.data : module
        ),
      };

    case POST_EDIT_MODULE_ERROR:
      return {
        ...state,
        isEditingModule: false,
        error: action.payload,
      }; 
    
    case GET_TUTORIAL_DETAILS:
        return {
          ...state,
          tutorailDetails: action.payload,
      };
    
    default:
      return state;
  }
};

export default moduleReducer;